import React from 'react';

interface AdmissionHistory {
  year: string;
  LQ: number | string;
  MED: number | string;
  UQ?: number | string;  // Upper Quartile (most universities)
  HA?: number | string;  // Highest Attainable (HKUST)
}

interface HistoricScoresProps {
  admissionHistory?: AdmissionHistory[];
  translate: any;
  maxRows?: number;
}

export const HistoricScores: React.FC<HistoricScoresProps> = ({ 
  admissionHistory, 
  translate,
  maxRows = 5
}) => {
  // Don't show if no admission history
  if (!admissionHistory || admissionHistory.length === 0) {
    return null;
  }

  // Don't show if all scores are 0 or invalid (new programmes)
  const hasValidScores = admissionHistory.some(history => {
    const lq = typeof history.LQ === 'number' ? history.LQ : 0;
    const med = typeof history.MED === 'number' ? history.MED : 0;
    const uq = typeof history.UQ === 'number' ? history.UQ : 0;
    const ha = typeof history.HA === 'number' ? history.HA : 0;
    
    return lq > 0 || med > 0 || uq > 0 || ha > 0;
  });

  if (!hasValidScores) {
    return null;
  }

  return (
    <div className="mt-4">
      <h5 className="text-xs font-medium text-slate-600 mb-2">{translate('historicScores')}</h5>
      <table className="w-full text-xs">
        <thead>
          <tr className="border-b border-slate-200">
            <th className="text-left py-1 px-2 font-semibold text-slate-700">{translate('year')}</th>
            <th className="text-right py-1 px-2 font-semibold text-red-600">LQ</th>
            <th className="text-right py-1 px-2 font-semibold text-yellow-700">MED</th>
            <th className="text-right py-1 px-2 font-semibold text-green-600">{admissionHistory.some(h => h.HA) ? 'HA' : 'UQ'}</th>
          </tr>
        </thead>
        <tbody>
          {admissionHistory.slice(0, maxRows).map((history, idx) => (
            <tr key={history.year} className={idx % 2 === 0 ? 'bg-white' : 'bg-slate-100'}>
              <td className={`py-1 px-2 text-slate-700 ${idx === 0 ? 'font-bold' : 'font-medium text-gray-500'}`}>
                {history.year}
              </td>
              <td className={`text-right py-1 px-2 ${idx === 0 ? 'text-red-600 font-bold' : 'text-red-400/80'}`}>
                {typeof history.LQ === 'number' && history.LQ > 0 ? history.LQ.toFixed(2) : '-'}
              </td>
              <td className={`text-right py-1 px-2 ${idx === 0 ? 'text-yellow-700 font-bold' : 'text-yellow-600/80'}`}>
                {typeof history.MED === 'number' ? history.MED.toFixed(2) : '-'}
              </td>
              <td className={`text-right py-1 px-2 ${idx === 0 ? 'text-green-600 font-bold' : 'text-green-500/80'}`}>
                {typeof history.HA === 'number' && history.HA > 0 ? history.HA.toFixed(2) : 
                 (typeof history.UQ === 'number' && history.UQ > 0 ? history.UQ.toFixed(2) : '-')}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
